import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { fetchData, sendEvent, useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import { useSearchParams } from "react-router-dom";
import star from "@assets/star.svg";
import { useQueryClient } from "@tanstack/react-query";
import Switch from "@components/Switch";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import DOMPurify from "dompurify";

function AnswersContent({
  currentQuestion,
  handlePickOneClick,
  handleMultiSelectClick,
  setInputValue,
  selected,
  multiSelect,
  inputValue,
  handleRangeChange,
  handleAnswerClick,
  handleInputChange,
  rangeValue,
  rangeInputRef,
  handleSwitchChange,
}) {
  const type = currentQuestion.type;
  const answers = currentQuestion.answers;

  switch (type) {
    case "select":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <button
              className={`answer ${selected === e.ident ? "selected" : ""}`}
              onClick={() => {
                handlePickOneClick(e.ident);
                if (e?.customCallback) {
                  e.customCallback();
                }
              }}
              key={index}
            >
              <div className="inner">
                <span className="oval" />
                <p>{e.answer}</p>
              </div>
            </button>
          ))}
        </div>
      );
    case "selectImg":
      return (
        <div className="answers-wrapper imgAnswer">
          {answers.map((e, index) => (
            <button
              className={`answer ${selected === e.ident ? "selected" : ""}`}
              onClick={() => {
                handlePickOneClick(e.ident);
                if (e?.customCallback) {
                  e.customCallback();
                }
              }}
              key={index}
            >
              <div className="inner">
                <img alt="answerIMG" src={e.answer} className="answerImg"></img>
              </div>
            </button>
          ))}
        </div>
      );
    case "select_other":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <React.Fragment key={index}>
              <button
                className={`answer ${selected === e.ident ? "selected" : ""}`}
                onClick={() => handlePickOneClick(e.ident)}
              >
                <div className="inner">
                  <span className="oval" />
                  <p>{e.answer}</p>
                </div>
              </button>
            </React.Fragment>
          ))}
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            min={3}
            placeholder="Geben Sie Ihre eigene Antwort ein"
            disabled={selected !== answers[answers.length - 1].ident}
          />
        </div>
      );
    case "nps":
      return (
        <div className={`nps`}>
          <div className="nps-content">
            {answers.map((e, index) => (
              <button
                className={`answer ${selected === e.ident ? "selected" : ""}`}
                onClick={() => {
                  handlePickOneClick(e.ident);
                  if (e?.customCallback) {
                    e.customCallback();
                  }
                }}
                key={index}
              >
                <div className="inner">
                  <p>{index}</p>
                </div>
              </button>
            ))}
          </div>
          <div className="nps-label">
            {answers.map((e, index) => (
              <span key={index}>{e.answer}</span>
            ))}
          </div>
        </div>
      );
    case "value":
      return (
        <div className="value">
          <div className="range-container">
            <div className="range-input-wrapper">
              <input
                className="range-input"
                ref={rangeInputRef}
                type="range"
                min="0"
                max={answers.length - 1}
                value={rangeValue}
                onChange={handleRangeChange}
                style={{ "--num-steps": answers.length }}
              />
              <div className="range-value">
                {/* /// wywalono + 1 na potrzeby ultrainsider_poll_2025 */}
                {parseInt(rangeValue, 10)}
                <img className="star" alt="star" src={star} />
              </div>
            </div>

            <div className="slider-brak-wrapper">
              {answers.map((e, index) => (
                <span className="slider-break" key={index}></span>
              ))}
              <span className="slider-break"></span>
            </div>
            <div className="range-label">
              {answers.map((e, index) => (
                <span key={index}>{e.answer}</span>
              ))}
            </div>
          </div>
          <div className="range-description">
            <p>0 = Gar nicht wahrscheinlich</p>
            <p>10 = Sehr wahrscheinlich</p>
          </div>
        </div>
      );
    case "order":
      return (
        <div className="order">
          {answers.map(({ answer }, index) => (
            <button
              className={`answer`}
              key={index}
              onClick={() => handleAnswerClick(index)}
            >
              <div className="inner">
                <input
                  type="text"
                  className="order-input"
                  maxLength="1"
                  onChange={(e) => handleInputChange(e, index)}
                />
                <p>{answer}</p>
              </div>
            </button>
          ))}
        </div>
      );
    case "multiselect":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <button
              className={`answer ${
                multiSelect.includes(e.ident) ? "selected" : ""
              }`}
              onClick={() => handleMultiSelectClick(e.ident)}
              key={index}
            >
              <div className="inner">
                <span className="oval" />
                <p>{e.answer}</p>
              </div>
            </button>
          ))}
        </div>
      );
    case "multiselect_other":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <button
              className={`answer ${
                multiSelect.includes(e.ident) ? "selected" : ""
              }`}
              onClick={() => handleMultiSelectClick(e.ident)}
              key={index}
            >
              <div className="inner">
                <span className="oval" />
                <p>{e.answer}</p>
              </div>
            </button>
          ))}
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            min={3}
            placeholder="Geben Sie Ihre eigene Antwort ein"
            disabled={!multiSelect.includes(answers[answers.length - 1].ident)}
          />
        </div>
      );
    case "multiselect_limit":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <button
              className={`answer ${
                multiSelect.includes(e.ident) ? "selected" : ""
              }`}
              onClick={() => handleMultiSelectClick(e.ident)}
              key={index}
            >
              <div className="inner">
                <span className="oval" />
                <p>{e.answer}</p>
              </div>
            </button>
          ))}
        </div>
      );
    case "multiselect_limit_other":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <button
              className={`answer ${
                multiSelect.includes(e.ident) ? "selected" : ""
              }`}
              onClick={() => handleMultiSelectClick(e.ident)}
              key={index}
            >
              <div className="inner">
                <span className="oval" />
                <p>{e.answer}</p>
              </div>
            </button>
          ))}
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            min={3}
            placeholder="Geben Sie Ihre eigene Antwort ein"
            disabled={!multiSelect.includes(answers[answers.length - 1].ident)}
          />
        </div>
      );
    case "input_open":
      return (
        <div className="answers-wrapper">
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            min={3}
            placeholder="Geben Sie Ihre eigene Antwort ein"
          />
        </div>
      );
    case "select_explain":
      return (
        <div className="answers-wrapper">
          {answers.map((e, index) => (
            <React.Fragment key={index}>
              <button
                className={`answer ${selected === e.ident ? "selected" : ""}`}
                onClick={() => handlePickOneClick(e.ident)}
              >
                <div className="inner">
                  <span className="oval" />
                  <p>{e.answer}</p>
                </div>
              </button>
              {selected === e.ident && (
                <input
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  min={3}
                  placeholder="Geben Sie Ihre eigene Antwort ein"
                />
              )}
            </React.Fragment>
          ))}
        </div>
      );
    case "terms":
      return (
        <div className="terms">
          {answers.map((e, index) => (
            <React.Fragment key={index}>
              <div className="switch-wrapper">
                {e.ident && (
                  <Switch
                    name={e.ident}
                    register={() => {}}
                    onChange={(event) => {
                      handleSwitchChange(e.ident, event.target.checked);
                    }}
                  />
                )}
                <p
                  className="switch-text"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(e.answer),
                  }}
                ></p>
              </div>
            </React.Fragment>
          ))}
          <br />
        </div>
      );
    default:
      null;
  }
}

export default function ConsumentPoll({ setAnswers, answers, setUserPayload }) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  let [_, setSearchParams] = useSearchParams();
  const [answersSend, setAnswersSend] = useState(false);

  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);

  const XGA = width >= 1020;

  const [selected, setSelected] = useState(-1);
  const [multiSelect, setMultiSelect] = useState([]);
  const [currentNode, setCurrentNode] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const currentQuestionContent = gameQuestionsQuery.content[currentNode];
  const [nextNodeObject, setNextNodeObject] = useState("*");
  const [isInputsValid, setIsInputsValid] = useState(false);
  const [userInputs, setUserInputs] = useState(
    Array(currentQuestionContent.answers.length - 1).fill(""),
  );
  const [rangeValue, setRangeValue] = useState(0);
  const rangeInputRef = useRef(null);
  const termsContent = gameQuestionsQuery.content.find(
    (item) => item.type === "terms",
  );
  const initialTerms = termsContent
    ? termsContent.answers.reduce((acc, item) => {
        if (item.ident) {
          acc[item.ident] = false;
        }
        return acc;
      }, {})
    : null;

  const [terms, setTerms] = useState(initialTerms);

  useEffect(() => {
    if (selected !== -1 && currentQuestionContent.adjacentTo) {
      const nextNode = currentQuestionContent.adjacentTo.find((e) => {
        if (typeof e === "object") {
          return e.value.includes(selected);
        }
        return e.value === selected;
      });
      setNextNodeObject(nextNode || null);
    } else {
      setNextNodeObject(null);
    }
  }, [selected, currentQuestionContent.adjacentTo]);

  useEffect(() => {
    if (multiSelect.length !== 0 && currentQuestionContent.adjacentTo) {
      const nextNode = currentQuestionContent.adjacentTo.find(
        (e) => e.value === multiSelect[multiSelect.length - 1],
      );
      setNextNodeObject(nextNode || null);
    } else {
      setNextNodeObject(null);
    }
  }, [multiSelect, currentQuestionContent.adjacentTo]);

  useEffect(() => {
    if (userInputs.length !== 0 && currentQuestionContent.adjacentTo) {
      const nextNode = currentQuestionContent.adjacentTo.find(
        (e) => e.value === userInputs[userInputs.length - 1],
      );
      setNextNodeObject(nextNode || null);
    } else {
      setNextNodeObject(null);
    }
  }, [userInputs, currentQuestionContent.adjacentTo]);

  useEffect(() => {
    if (
      currentQuestionContent.type === "input_open" &&
      inputValue.length > 0 &&
      currentQuestionContent.adjacentTo
    ) {
      const nextNode = currentQuestionContent.adjacentTo.find((e) => e?.value);
      setNextNodeObject(nextNode || null);
    }
  }, [inputValue, currentQuestionContent.adjacentTo]);

  function handleNextClick() {
    const type = currentQuestionContent.type;
    let newAnswers = answers;
    let answer_ident;
    let consumerData = [];

    switch (type) {
      case "select":
        answer_ident = selected;
        newAnswers.push({
          question_ident: currentQuestionContent.ident,
          answer_ident,
        });
        break;

      case "selectImg":
        answer_ident = selected;
        newAnswers.push({
          question_ident: currentQuestionContent.ident,
          answer_ident,
        });
        break;

      case "select_other":
        if (inputValue.length !== 0) {
          newAnswers.push({
            question_ident: `${currentQuestionContent.ident}`,
            answer_ident: inputValue,
          });
        } else {
          answer_ident = selected;
          newAnswers.push({
            question_ident: currentQuestionContent.ident,
            answer_ident,
          });
        }
        break;

      case "nps":
        answer_ident = selected;
        newAnswers.push({
          question_ident: currentQuestionContent.ident,
          answer_ident,
        });
        break;

      case "value":
        answer_ident = selected;
        newAnswers.push({
          question_ident: currentQuestionContent.ident,
          answer_ident,
        });
        break;

      case "order":
        answer_ident = userInputs;
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident,
        });
        break;

      case "multiselect":
        answer_ident = multiSelect;
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident,
        });
        break;

      case "multiselect_other":
        if (inputValue.length !== 0) {
          newAnswers.push({
            question_ident: `${currentQuestionContent.ident}`,
            answer_ident: inputValue,
          });
        } else {
          answer_ident = multiSelect;
          newAnswers.push({
            question_ident: `${currentQuestionContent.ident}`,
            answer_ident,
          });
        }
        break;
      case "multiselect_limit":
        answer_ident = multiSelect;
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident,
        });
        break;

      case "multiselect_limit_other":
        answer_ident = multiSelect;
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident,
        });
        if (inputValue.length !== 0) {
          newAnswers.push({
            question_ident: `${currentQuestionContent.ident}`,
            answer_ident: inputValue,
          });
        }
        break;

      case "input_open":
        newAnswers.push({
          question_ident: currentQuestionContent.ident,
          answer_ident: inputValue,
        });
        break;

      case "select_explain":
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident: selected,
        });
        newAnswers.push({
          question_ident: `${currentQuestionContent.ident}`,
          answer_ident: inputValue,
        });

      case "terms":
        answer_ident = "terms";
        consumerData.push({
          ...terms,
        });
        break;
      default:
        break;
    }

    if (!nextNodeObject) {
      if (currentQuestionContent.adjacentTo) {
        const universalAdjacent = currentQuestionContent.adjacentTo.find(
          (e) => e.value === "*",
        );
        if (universalAdjacent) {
          setNextNodeObject(universalAdjacent);
        }
      }
    }

    setAnswers(newAnswers);

    if (!nextNodeObject) {
      const completeAnswers = gameQuestionsQuery.content.map((question) => {
        const existing = answers.find(
          (a) => a.question_ident === question.ident,
        );
        return (
          existing ?? { question_ident: question.ident, answer_ident: "null" }
        );
      });

      setAnswersSend(true);

      fetchData({
        endpoint:
          ident === "subscription_poll"
            ? "/subscription/activation/solution/create"
            : "/activation/solution/create",
        payload: {
          activation: {
            ident: ident,
            payload: completeAnswers,
          },
        },
        successCallback: (resObj) => {
          setUserPayload(resObj?.data);
          sendEvent(`${ident}_FINISH`);
          setSearchParams({ status: "success" }, { replace: true });
        },
      });

      return;
    }

    setCurrentNode(nextNodeObject?.node);
    setSelected(-1);
    setMultiSelect([]);
    setInputValue("");
    setRangeValue(0);
    if (rangeInputRef.current) {
      rangeInputRef.current.value = 0; // Reset the actual input value
      rangeInputRef.current.style.setProperty("--value", "0%"); // Reset the visual representation of the slider
    }
  }

  function handlePickOneClick(answerIdent) {
    setSelected(answerIdent);
    setInputValue("");
  }

  const handleRangeChange = (event) => {
    const index = event.target.value;
    const answers = currentQuestionContent.answers;
    setSelected(answers[index].ident);
    setRangeValue(index);

    const percentage = ((parseInt(index, 10) + 1) / answers.length) * 100;
    event.target.style.setProperty("--value", `${percentage}%`);
  };

  const handleSwitchChange = (name, value) => {
    setTerms((prevTerms) => ({
      ...prevTerms,
      [name]: value ?? false,
    }));
  };

  useEffect(() => {
    if (rangeInputRef.current) {
      const percentage =
        ((parseInt(rangeValue, 10) + 1) /
          currentQuestionContent.answers.length) *
        100;
      rangeInputRef.current.style.setProperty("--value", `${percentage}%`);
    }
  }, [rangeValue, currentQuestionContent.answers.length]);

  function handleMultiSelectClick(answerIdent) {
    let newAnswers = [...multiSelect];
    const { multiselectLimit } = currentQuestionContent;

    if (newAnswers.includes(answerIdent)) {
      newAnswers = newAnswers.filter((e) => e !== answerIdent);
      setMultiSelect(newAnswers);
      return;
    }
    if (multiselectLimit && newAnswers.length >= multiselectLimit) {
      newAnswers.shift();
    }
    newAnswers.push(answerIdent);
    setMultiSelect(newAnswers);
    return;
  }

  useEffect(() => {
    checkInputsValidity();
  }, [userInputs]);

  const handleAnswerClick = (index) => {
    setSelected(index);
  };

  const checkInputsValidity = () => {
    let allInputsValid = true;
    let valuesSet = new Set();

    for (let inputValue of userInputs) {
      if (!inputValue || valuesSet.has(inputValue)) {
        allInputsValid = false;
        break;
      }
      valuesSet.add(inputValue);
    }

    if (allInputsValid) {
      const numericValues = Array.from(valuesSet).map(
        (value) => value.charCodeAt(0) - 96,
      );
      numericValues.sort((a, b) => a - b);
      for (let i = 0; i < numericValues.length; i++) {
        if (numericValues[i] !== i + 1) {
          allInputsValid = false;
          break;
        }
      }
    }
    setIsInputsValid(allInputsValid);
  };

  const handleInputChange = (e, index) => {
    const inputValue = e.target.value;
    if (!isNaN(inputValue) && inputValue !== "") {
      const numericValue = parseInt(inputValue, 10);

      const alphabeticValue = String.fromCharCode(96 + numericValue); // 97 to 'a' w kodzie ASCII
      setUserInputs((prevInputs) => {
        const newInputs = [...prevInputs];
        newInputs[index] = alphabeticValue;
        return newInputs;
      });
    }
  };

  function buttonDisabler() {
    const type = currentQuestionContent.type;
    const answers = currentQuestionContent.answers;

    if (answersSend) {
      return true;
    }

    switch (type) {
      case "select":
        return selected === -1;
      case "selectImg":
        return selected === -1;
      case "select_other":
        const isOpenAnswerSelectedSingle =
          selected === answers[answers.length - 1].ident;
        if (!isOpenAnswerSelectedSingle) {
          return selected === -1;
        }
        return !(inputValue.length !== 0 && selected !== -1);

      case "nps":
        return selected === -1;
      case "value":
        return selected === -1;
      case "order":
        if (isInputsValid) {
          return false;
        }
        return true;
      case "multiselect":
        if (multiSelect.length !== 0) {
          return false;
        }
        return true;
      case "multiselect_other":
        const isOpenAnswerSelected = multiSelect.includes(
          answers[answers.length - 1].ident,
        );
        if (multiSelect.length !== 0) {
          if (isOpenAnswerSelected) {
            if (inputValue.length !== 0) {
              return false;
            }
            return true;
          }
          return false;
        }
        return true;
      case "multiselect_limit":
        if (
          multiSelect.length !== 0 &&
          multiSelect.length <= currentQuestionContent.limit
        ) {
          return false;
        }
        return true;
      case "multiselect_limit_other":
        const isOpenAnswerSelectedLimit = multiSelect.includes(
          answers[answers.length - 1].ident,
        );
        if (multiSelect.length !== 0) {
          if (isOpenAnswerSelectedLimit) {
            if (inputValue.length !== 0) {
              return false;
            }
            return true;
          }
          return false;
        }
        return true;
      case "input_open":
        return inputValue.length === 0;
      case "select_explain":
        return !(inputValue.length !== 0 && selected !== -1);
      case "terms":
        return !answers
          .filter((answer) => answer.ident && answer.required)
          .every((answer) => terms[answer.ident]);
      default:
        return true;
    }
  }

  const isUltraInsider =
    location.pathname.includes("subscription") ||
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  console.log(answers);
  console.log("currentNode", currentNode);
  console.log("nextNodeObject.node", nextNodeObject?.node);

  return (
    <section
      className={`game-page poll-mechanics dag-poll-mechanics ${ident} ${isUltraInsider ? "ultra-insider" : ""}`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentNode / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(currentQuestionContent.question),
                }}
              />
            </div>
            <div
              className={`answer-content ${
                currentQuestionContent.type === "selectImg" ? "imgAnswer" : ""
              }`}
            >
              <AnswersContent
                currentQuestion={currentQuestionContent}
                handleMultiSelectClick={handleMultiSelectClick}
                handlePickOneClick={handlePickOneClick}
                inputValue={inputValue}
                multiSelect={multiSelect}
                selected={selected}
                setInputValue={setInputValue}
                handleRangeChange={handleRangeChange}
                handleAnswerClick={handleAnswerClick}
                handleInputChange={handleInputChange}
                rangeValue={rangeValue}
                rangeInputRef={rangeInputRef}
                handleSwitchChange={handleSwitchChange}
              />
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            <img src={gameQuestionsQuery.sideImgMobile} alt="" />
            {XGA && (
              // replace "StickyContent" with something called respectively
              <StickyContent>
                <div className="desktop-buttons">
                  <Button action={handleNextClick} disabled={buttonDisabler()}>
                    {currentQuestionContent.customButtonCopy || "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton action={handleNextClick} disabled={buttonDisabler()}>
          {currentQuestionContent.customButtonCopy || "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
